import { Navigation as NavigationEditor } from "./navigation"
import { NavigationSettings } from "./navigation-settings"
import NavigationPreview from "./navigation-preview.png"

export const Navigation = {
  name: "Navigation",
  label: "Navigation",
  EditorComponent: NavigationEditor,
  SettingsComponent: NavigationSettings,
  image: NavigationPreview,
  defaultProperties: {
    items: [
      { text: "WHAT'S NEW", url: "" },
      { text: "SHOP", url: "" },
      { text: "TOUR", url: "" },
      { text: "YOUTUBE", url: "" },
      { text: "BOOK", url: "" }
    ],
    backgroundColor: "#773434",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: "#f0f0f0",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    textColor: "#efefef"
  },
  defaultChildren: []
}
